import { render, staticRenderFns } from "./CommonDetail.vue?vue&type=template&id=0ab4cd50&scoped=true"
import script from "./CommonDetail.vue?vue&type=script&lang=js"
export * from "./CommonDetail.vue?vue&type=script&lang=js"
import style0 from "./CommonDetail.vue?vue&type=style&index=0&id=0ab4cd50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab4cd50",
  null
  
)

export default component.exports